import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../../services/api'
import { useAuth } from '../../contexts/AuthContext'
import { translateApiError } from '../../utils/errorMessages'
import { usePageHeader } from '../../contexts/PageHeaderContext'
import { Button, RoleBadge } from '../../components/ui'
import Icon from '../../components/Icon'
import './Admin.css'

function AdminUsersList() {
  const { user } = useAuth()
  const canCreate = user?.permissions?.['users.create']
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    fetchUsers()
  }, [])

  const fetchUsers = async () => {
    try {
      setLoading(true)
      const response = await api.get('/admin/users')
      if (response.data?.users) {
        setUsers(response.data.users)
      } else {
        setUsers([])
      }
    } catch (error) {
      console.error('Error fetching users:', error)
      alert('Ошибка загрузки пользователей: ' + translateApiError(error.response?.data?.error || error.message))
      setUsers([])
    } finally {
      setLoading(false)
    }
  }

  usePageHeader({
    renderActions: () => canCreate ? (
      <Button variant="primary" onClick={() => navigate('/admin/users/new')}>
        + Создать пользователя
      </Button>
    ) : null
  }, [canCreate])

  if (loading) return <div className="admin-page">Загрузка...</div>

  return (
    <div className="admin-page">
      <div className="admin-table-frame">
        <div className="table-responsive">
          <table className="ui-table data-table">
            <thead>
              <tr>
                <th>Логин</th>
                <th>Роль</th>
                <th>Сотрудник</th>
                <th>Статус</th>
                <th>Создан</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {users.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                    Пользователи не найдены
                  </td>
                </tr>
              ) : (
                users.map((user) => (
                  <tr key={user.id}>
                    <td>{user.login}</td>
                    <td>
                      <RoleBadge role={user.role} />
                    </td>
                    <td>{user.employee_name || '-'}</td>
                    <td>{user.is_active ? 'Активен' : 'Неактивен'}</td>
                    <td>{user.created_at ? new Date(user.created_at).toLocaleDateString('ru-RU') : '-'}</td>
                    <td>
                      <div className="user-actions-cell">
                        <Button
                          type="button"
                          variant="secondary"
                          className="user-action-icon"
                          aria-label="Редактировать"
                          title="Редактировать"
                          onClick={() => navigate(`/admin/users/${encodeURIComponent(user.id)}/edit`)}
                        >
                          <Icon name="edit" size={18} />
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default AdminUsersList
